import { TemplatePdf } from "@/modules/TemplatePdf/Models/templatePdf";
import { TemplatesPdfResponseChart } from "@/modules/TemplatePdf/Models/templatesPdfResponseChart";
import { Response } from "@/shared/models/Response";
import axios from "axios";
import { TemplatePdfQuery } from "../Models/templatePdfQuery";

export class TemplatePdfService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/templatespdf`;
  }

  async saveTemplate(template: TemplatePdf) {
    const serviceURL = this.baseUrl;
    const responseData = await axios.post(serviceURL, template);
    return responseData.data;
  }

  async getTemplateById(id: string): Promise<Response<TemplatePdf | void>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const responseData = await axios.get(serviceURL);

    return responseData.data;
  }

  async updateTemplate(template: TemplatePdf, id: string) {
    const serviceURL = `${this.baseUrl}/${id}`;
    const responseData = await axios.put(serviceURL, template);
    return responseData.data;
  }

  async getDataInitial(
    query: TemplatePdfQuery
  ): Promise<Response<TemplatesPdfResponseChart>> {
    const serviceURL = `${this.baseUrl}/find-by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async deleteTemplate(id: string) {
    const serviceURL = `${this.baseUrl}/delete/${id}`;
    const response = await axios.delete(serviceURL);
    return response.data;
  }

  async changeStatus(itemId: string, state: string) {
    const serviceURL = `${this.baseUrl}/change-status/${itemId}`;
    const response = await axios.put(serviceURL, { state });
    return response.data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        nameTemplatePdf: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }
}
